const n = "#ffffff", t = "#f7f9fc", s = "#eff2f9", d = "#e7eaf4", f = "#d9deeb", a = "#bec4d5", r = "#9fa6bb", b = "#828ba2", p = "#656e83", i = "#495163", l = "#303848", g = "#1e2532", x = "#0f141e", u = "#eaf6ff", m = "#d6ecfe", B = "#c3e5fe", k = "#92cdfc", I = "#54aff8", N = "#1a91f0", G = "#1170cd", O = "#10529b", R = "#0f3871", A = "#0c264c", X = "#09162d", S = "#f1f2ff", L = "#e4e6fe", v = "#dbdeff", C = "#bec2fe", V = "#9ba1fb", P = "#7a82f5", $ = "#5660e8", h = "#343ecc", j = "#282b8f", w = "#1a1c6a", M = "#0e0f47", U = "#edefff", W = "#e7f4ed", Z = "#d5ebde", q = "#c6e4d2", y = "#96d0ad", z = "#48ba75", D = "#339d5d", E = "#217d47", F = "#135c37", H = "#094025", J = "#042b18", K = "#01180d", Q = "#fff2cc", T = "#fddb8c", Y = "#f9ba44", _ = "#ec930c", ee = "#cf760d", oe = "#a85a0e", ce = "#7f400d", ne = "#582c0c", te = "#3e1d0a", se = "#231007", de = "#feebe3", fe = "#fdd2c0", ae = "#fbb092", re = "#f68559", be = "#ee571d", pe = "#bf4213", ie = "#8b3211", le = "#5e240e", ge = "#3b180b", xe = "#1c0c06", ue = "#ffeaec", me = "#ffd0d5", Be = "#ffacb5", ke = "#fe7d8b", Ie = "#fb4458", Ne = "#da0c22", Ge = "#a10e1d", Oe = "#6f0e19", Re = "#470c12", Ae = "#24090c", Xe = "#f3f1eb", Se = "#e1ddd2", Le = "#cbc3b3", ve = "#afa58f", Ce = "#968a70", Ve = "#776d59", Pe = "#575041", $e = "#3c372d", he = "#27241d", je = "#15130f", Ue = {
  White: n,
  Neutral5: t,
  Neutral10: s,
  Neutral15: d,
  Neutral20: f,
  Neutral30: a,
  Neutral40: r,
  Neutral50: b,
  Neutral60: p,
  Neutral70: i,
  Neutral80: l,
  Neutral90: g,
  Neutral100: x,
  Blue10: u,
  Blue15: m,
  Blue20: B,
  Blue30: k,
  Blue40: I,
  Blue50: N,
  Blue60: G,
  Blue70: O,
  Blue80: R,
  Blue90: A,
  Blue100: X,
  Indigo10: S,
  Indigo15: L,
  Indigo20: v,
  Indigo30: C,
  Indigo40: V,
  Indigo50: P,
  Indigo60: $,
  Indigo70: h,
  Indigo80: j,
  Indigo90: w,
  Indigo100: M,
  Indigo110: U,
  Green10: W,
  Green15: Z,
  Green20: q,
  Green30: y,
  Green40: z,
  Green50: D,
  Green60: E,
  Green70: F,
  Green80: H,
  Green90: J,
  Green100: K,
  Amber10: Q,
  Amber20: T,
  Amber30: Y,
  Amber40: _,
  Amber50: ee,
  Amber60: oe,
  Amber70: ce,
  Amber80: ne,
  Amber90: te,
  Amber100: se,
  Orange10: de,
  Orange20: fe,
  Orange30: ae,
  Orange40: re,
  Orange50: be,
  Orange60: pe,
  Orange70: ie,
  Orange80: le,
  Orange90: ge,
  Orange100: xe,
  Red10: ue,
  Red20: me,
  Red30: Be,
  Red40: ke,
  Red50: Ie,
  Red60: Ne,
  Red70: Ge,
  Red80: Oe,
  Red90: Re,
  Red100: Ae,
  Beige10: Xe,
  Beige20: Se,
  Beige30: Le,
  Beige40: ve,
  Beige50: Ce,
  Beige60: Ve,
  Beige70: Pe,
  Beige80: $e,
  Beige90: he,
  Beige100: je
}, we = "spacing", Me = { Zero: { desktop: "0px", mobile: "0px" }, "4XS": { desktop: "2px", mobile: "2px" }, "3XS": { desktop: "4px", mobile: "4px" }, "2XS": { desktop: "8px", mobile: "8px" }, XS: { desktop: "12px", mobile: "10px" }, S: { desktop: "16px", mobile: "12px" }, M: { desktop: "24px", mobile: "20px" }, L: { desktop: "32px", mobile: "24px" }, XL: { desktop: "48px", mobile: "32px" }, "2XL": { desktop: "64px", mobile: "48px" }, "3XL": { desktop: "96px", mobile: "64px" }, "4XL": { desktop: "128px", mobile: "96px" }, "5XL": { desktop: "192px", mobile: "128px" }, "6XL": { desktop: "256px", mobile: "192px" } }, o = {
  cssVarPrefix: we,
  values: Me
}, We = Object.keys(o.values).reduce(
  (c, e) => ({ ...c, [e]: `var(--${o.cssVarPrefix}-${e.toUpperCase()})` }),
  {}
);
export {
  Ue as C,
  We as S
};
